import React from 'react';

// Components

import BlockWrapper from '@components/hyperDashboard/blocks/BlockWrapper';

// Constants

import { flowTypes } from '@constants/ssap/flows/flowTypes';

const AttestationInfo = props => {
    const {
        attestationsConfig = { },
        id,
        flowType,
        stateCode,
    } = props;

    const getAttestations = () => {
        if(!attestationsConfig[stateCode]) {
            return null;
        }
        return attestationsConfig[stateCode]
            .map(attestation => {
                const {
                    attestationName,
                    isVisible = true
                } = attestation;

                return (
                    <div key = { attestationName } >
                        <span style = { { color: !isVisible ? 'red' : 'initial', fontSize: '1.2rem' } }>
                            { attestationName }
                        </span>
                    </div>
                );
            });
    };

    return (
        <BlockWrapper
            id = { id }
            additionalStyles = { { width: 300 } }
        >
            <div style = { { fontSize: '1.5rem', marginTop: '1rem' } } >
                Rendered Attestations <br/>
                State: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                <strong>{stateCode}</strong> <br/>
                Flow type: &nbsp; &nbsp; &nbsp;
                <strong>
                    {
                        flowType === flowTypes.FINANCIAL_FLOW
                            ? 'Financial'
                            : 'Non-Financial'
                    }
                </strong>
            </div>
            <div style = { { marginTop: '1rem' } } >
                {
                    getAttestations()
                }
            </div>
        </BlockWrapper>
    );
};

export default AttestationInfo;